import React, { useState, useRef } from "react";
import api, { API, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileText, X, Loader2, Image as ImageIcon } from "lucide-react";

export function fileUrl(path) {
  return path ? `${API}/files/${path}` : "";
}

export function FileUpload({ label, value, onChange, accept = ".pdf,.png,.jpg,.jpeg,.webp", kind = "file", testid = "file-upload" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);
  const isImage = kind === "image";

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path, data.filename);
      toast.success("File uploaded");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className="mb-1 block text-sm font-semibold text-[#2D1E18]">{label}</label>}
      {value ? (
        <div className="flex items-center gap-3 rounded-xl border border-border bg-secondary p-3" data-testid={`${testid}-preview`}>
          {isImage ? <img src={fileUrl(value)} alt="preview" className="h-14 w-14 rounded-lg object-cover" /> : <FileText size={28} className="text-[#B04B26]" />}
          <a href={fileUrl(value)} target="_blank" rel="noopener noreferrer" className="flex-1 truncate text-sm font-semibold text-[#B04B26] hover:underline">View uploaded {isImage ? "image" : "PDF"}</a>
          <button type="button" onClick={() => onChange("", "")} aria-label="Remove file" className="rounded-lg p-1.5 text-[#6E5B51] hover:text-[#991B1B]"><X size={16} /></button>
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} data-testid={testid}
          className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-border bg-white px-4 py-4 text-sm font-semibold text-[#5C4A42] hover:border-[#C85A32] hover:text-[#B04B26] disabled:opacity-60">
          {uploading ? <><Loader2 size={16} className="animate-spin" /> Uploading…</> : <>{isImage ? <ImageIcon size={16} /> : <Upload size={16} />} Upload {isImage ? "image" : "PDF"}</>}
        </button>
      )}
      <input ref={inputRef} type="file" accept={accept} onChange={handle} className="hidden" data-testid={`${testid}-input`} />
    </div>
  );
}
